// provider.config.ts - Contains only configuration data
import { ProviderKey } from '@type/provider';

export interface ProviderModel {
  id: string;
  name: string;
  maxCompletionTokens: number;
  cost: {
    input: { price: number, unit: number };
    output: { price: number, unit: number };
  };
}

export interface ProviderConfig {
  id: ProviderKey;
  name: string;
  defaultModel: string;
  endpoints: string[];
  models: ProviderModel[];
  capabilities: {
    supportsThinking: boolean;
    supportsFileUpload?: boolean;
  };
}

// Configuration data only - no dependencies on implementations
export const PROVIDER_CONFIGS: Record<ProviderKey, ProviderConfig> = {
  anthropic: {
    id: 'anthropic',
    name: 'Anthropic',
    defaultModel: 'claude-sonnet-4-6',
    // Always use the secure proxy endpoint
    endpoints: ['/api/chat/anthropic'],
    models: [
      {
        id: 'claude-sonnet-4-6',
        name: 'Claude 4.6 Sonnet',
        maxCompletionTokens: 8192,
        cost: {
          input: { price: 0.003, unit: 1000 },
          output: { price: 0.015, unit: 1000 }
        }
      },
      {
        id: 'claude-sonnet-4-5',
        name: 'Claude 4.5 Sonnet',
        maxCompletionTokens: 8192,
        cost: {
          input: { price: 0.003, unit: 1000 },
          output: { price: 0.015, unit: 1000 }
        }
      },
      {
        id: 'claude-haiku-4-5',
        name: 'Claude 4.5 Haiku',
        maxCompletionTokens: 8192,
        cost: {
          input: { price: 0.001, unit: 1000 },
          output: { price: 0.005, unit: 1000 }
        }
      },
      // Other models...
    ],
    capabilities: {
      supportsThinking: true
    }
  },
  openai: {
    id: 'openai',
    name: 'OpenAI',
    defaultModel: 'gpt-5.2',
    // Always use the secure proxy endpoint
    endpoints: ['/api/chat/openai'],
    models: [
      {
        id: 'gpt-5.2',
        name: 'GPT-5.2',
        maxCompletionTokens: 16384,
        cost: {
          input: { price: 1.75, unit: 1000 },
          output: { price: 14.00, unit: 1000 }
        }
      },
      {
        id: 'gpt-5.1',
        name: 'GPT-5.1',
        maxCompletionTokens: 16384,
        cost: {
          input: { price: 1.25, unit: 1000 },
          output: { price: 10.00, unit: 1000 }
        }
      },
      {
        id: 'gpt-4o',
        name: 'GPT-4o',
        maxCompletionTokens: 16384,
        cost: {
          input: { price: 0.0025, unit: 1000 },
          output: { price: 0.01, unit: 1000 }
        }
      },
      // Other models...
    ],
    capabilities: {
      supportsThinking: false
    }
  },
  deepinfra: {
    id: 'deepinfra',
    name: 'DeepInfra',
    defaultModel: 'openai/gpt-oss-120b',
    endpoints: ['/api/chat/deepinfra'],
    models: [
      {
        id: 'openai/gpt-oss-120b',
        name: 'GPT-OSS 120B',
        maxCompletionTokens: 4096,
        cost: {
          input: { price: 0.039, unit: 1000000 },
          output: { price: 0.19, unit: 1000000 }
        }
      }
    ],
    capabilities: {
      supportsThinking: false
    }
  }
};